import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';

/**
 * 全局加载
 */
@Component({ name: 'CcLoading' })
export default class extends Vue {
    /**
     * 是否在加载
     */
    public get loading(): boolean {
        return AppModule.appLoading;
    }
}
